import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';


class HomeIndexController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices
  ) {
    $scope.pageHeader = 'Home';
    $scope.tooltips = {
      // archivia: 'Archivia, organizza, scarica e condividi tuoi documenti in tutta sicurezza.',
      fattura: 'Crea, carica, trasmetti o verifica le tue Fatture Elettroniche.',
      conserva: 'Conserva a norma di legge i tuoi documenti informatici.\nPuoi anche ricercarli o scaricarli in caso di controllo di un pubblico ufficiale.',
      // conservaPEC: 'Conservare la PEC è un obbligo!\nConserva a norma di Legge i tuoi messaggi di posta elettronica certificata.'
    };
  }
}

export const HomeIndexComponent: ng.IComponentOptions = {
  template: require('./home-index.html'),
  controller: HomeIndexController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/home-index/home-index.ts